import { useReducer } from 'react';
import produce from 'immer';

const CHECK = 'CHECK';
const CHECK_GROUP = 'CHECK_GROUP';
const CHECK_ALL = 'CHECK_ALL';

export const tripFilters = {
  CHECK,
  CHECK_GROUP,
  CHECK_ALL,
};

const reducer = (state, action) => {
  const { group, filter, vendor, selected } = action;
  switch (action.type) {
    case CHECK:
      return produce(state, (draft) => {
        draft[group][filter].items[vendor].checked = !state[group][filter].items[vendor].checked;
        draft[group][filter].checked = !Object.values(draft[group][filter].items).some(
          (i) => !i.checked
        );
      });
    case CHECK_GROUP:
      return produce(state, (draft) => {
        draft[group][filter].checked = selected;
        Object.keys(draft[group][filter].items).forEach((key) => {
          draft[group][filter].items[key].checked = selected;
        });
      });
    case CHECK_ALL:
      return produce(state, (draft) => {
        Object.keys(state[group]).forEach((key) => {
          draft[group][key].checked = selected;
          Object.keys(state[group][key].items).forEach((item) => {
            draft[group][key].items[item].checked = selected;
          });
        });
      });
    default:
      return state;
  }
};

export const isAllChecked = (group) => {
  return !Object.values(group).some((filter) =>
    Object.values(filter.items).some((i) => !i.checked)
  );
};

function hasCheckedItem(obj) {
  // Check if there is at least one checked item in the given object
  if (obj != null) {
    for (const groupKey in obj) {
      const group = obj[groupKey];
      if (group.items != null) {
        for (const itemKey in group.items) {
          const item = group.items[itemKey];
          if (item.checked) {
            return true;
          }
        }
      }
    }
  }
  return false;
}

const isValidFilter = (groups) => {
  if (!groups) {
    return false;
  }

  const starHasCheckedItem = hasCheckedItem(groups?.star);
  const neighborhoodHasCheckedItem = hasCheckedItem(groups?.neiborhood?.group?.items);
  // Check if both have at least one checked item
  return starHasCheckedItem && neighborhoodHasCheckedItem;
};

const useTripFilters = (hotelFilters) => {
  const [filters, dispatchFilter] = useReducer(reducer, hotelFilters);
  const disableButton = isValidFilter(filters);

  return [disableButton, filters, dispatchFilter];
};

export default useTripFilters;
